<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="engineRubricSkill !== undefined" model="Assessment"></app-form-title>
	<app-engine-dropdown-field
		[fg]="form"
		formGroupOrControlName="engine_name"
		label="Engine Name"
	></app-engine-dropdown-field>
	<app-rubric-dropdown-field
		[fg]="form"
		formGroupOrControlName="rubric_code"
		label="Rubric"
	></app-rubric-dropdown-field>
	<app-skill-code-dropdown-field
		[fg]="form"
		formGroupOrControlName="skill_code"
		label="Skill Code"
	></app-skill-code-dropdown-field>
	<app-textarea-field [fg]="form" formGroupOrControlName="assessment" label="Assessment"></app-textarea-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
